import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import StatusPill from '../components/UI/StatusPill';

export default function SupplierPortal() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [detail, setDetail] = useState(null);
  const [deliveryDate, setDeliveryDate] = useState('');
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  const load = () => {
    fetch('/api/portal/' + token).then(r => r.json()).then(r => {
      if (r.success) setData(r.data);
      else setError(r.error || 'Invalid link');
    }).catch(() => setError('Failed to load'));
  };

  useEffect(() => { load(); }, [token]);

  const viewOrder = (poId) => {
    fetch('/api/portal/' + token + '/orders/' + poId).then(r => r.json()).then(r => {
      if (r.success) setDetail(r.data);
    });
  };

  const confirmOrder = (poId) => {
    fetch('/api/portal/' + token + '/orders/' + poId + '/confirm', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ delivery_date: deliveryDate })
    }).then(r => r.json()).then(r => {
      if (r.success) { setMsg('Order confirmed!'); setDetail(null); load(); }
    });
  };

  if (error) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0D1B2A' }}>
      <div style={{ background: '#1A2F4A', padding: 40, borderRadius: 16, textAlign: 'center' }}>
        <h2 style={{ color: '#E74C3C' }}>Portal Error</h2>
        <p style={{ color: '#B8C8D8', marginTop: 12 }}>{error}</p>
      </div>
    </div>
  );

  if (!data) return <div style={{ padding: 40, color: '#B8C8D8', textAlign: 'center' }}>Loading portal...</div>;

  return (
    <div style={{ minHeight: '100vh', background: '#0D1B2A', padding: '32px' }}>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
          <div>
            <h1 style={{ fontFamily: 'Lora, serif', fontSize: 28 }}>
              <span style={{ color: '#fff' }}>Stock</span><span style={{ color: '#C9A84C' }}>Pour</span>
            </h1>
            <p style={{ color: '#B8C8D8', fontSize: 14 }}>Supplier Portal</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontWeight: 600, color: '#C9A84C' }}>{data.supplier.name}</div>
            <div style={{ fontSize: 13, color: '#B8C8D8' }}>{data.supplier.contact_name}</div>
          </div>
        </div>

        {msg && <div style={{ background: 'rgba(46,204,113,0.15)', color: '#2ECC71', padding: '10px 16px', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>{msg}</div>}

        <h2 style={{ color: '#C9A84C', marginBottom: 16, fontFamily: 'Lora, serif' }}>Open Orders</h2>

        {data.orders.length === 0 ? (
          <div style={{ background: '#1A2F4A', padding: 32, borderRadius: 12, textAlign: 'center', color: '#B8C8D8' }}>No open orders</div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>PO #</th><th>Location</th><th>Status</th><th>Total</th><th>Created</th><th>Action</th></tr></thead>
              <tbody>
                {data.orders.map(o => (
                  <tr key={o.id}>
                    <td style={{ fontWeight: 600, color: '#C9A84C' }}>{o.po_number}</td>
                    <td>{o.location_name}</td>
                    <td><StatusPill status={o.status} /></td>
                    <td>${Number(o.total_amount).toFixed(2)}</td>
                    <td>{new Date(o.created_at).toLocaleDateString()}</td>
                    <td><button className="btn btn-primary btn-sm" onClick={() => viewOrder(o.id)}>View</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {detail && (
          <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setDetail(null)}>
            <div className="modal" style={{ maxWidth: 640 }}>
              <h2>PO {detail.po_number}</h2>
              <div style={{ marginBottom: 16 }}>
                <span style={{ color: '#B8C8D8', fontSize: 13 }}>Location: </span>{detail.location_name}
                <span style={{ marginLeft: 20, color: '#B8C8D8', fontSize: 13 }}>Status: </span><StatusPill status={detail.status} />
              </div>
              <div className="table-wrap">
                <table>
                  <thead><tr><th>Product</th><th>SKU</th><th>Qty</th><th>Unit Cost</th><th>Total</th></tr></thead>
                  <tbody>
                    {(detail.items || []).map(i => (
                      <tr key={i.id}>
                        <td>{i.product_name}</td>
                        <td style={{ color: '#4A6A8A' }}>{i.sku}</td>
                        <td>{Number(i.qty_ordered).toFixed(0)}</td>
                        <td>${Number(i.unit_cost).toFixed(2)}</td>
                        <td>${Number(i.line_total).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={{ fontWeight: 700, textAlign: 'right', marginTop: 12, fontSize: 16, color: '#C9A84C' }}>Total: ${Number(detail.total_amount).toFixed(2)}</div>

              {detail.status === 'sent' && (
                <div style={{ marginTop: 20, padding: 16, background: '#0A1628', borderRadius: 8 }}>
                  <div className="form-group">
                    <label style={{ color: '#B8C8D8' }}>Estimated Delivery Date</label>
                    <input type="date" value={deliveryDate} onChange={e => setDeliveryDate(e.target.value)} />
                  </div>
                  <button className="btn btn-primary" onClick={() => confirmOrder(detail.id)} style={{ width: '100%', justifyContent: 'center' }}>Confirm Order</button>
                </div>
              )}
              <div className="modal-actions"><button className="btn btn-secondary" onClick={() => setDetail(null)}>Close</button></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
